<template>
    <div>
        <el-form :inline="true" :model="systemOrderForm">
            <el-form-item label="ICCID号：">
                <el-input></el-input>
            </el-form-item>
            <el-form-item label="接入号：">
                <el-input></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary">搜索查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tableData" @selection-change="handleSelectionChange">
            <el-table-column type="index" label="序号"></el-table-column>      
            <el-table-column prop="3" label="ICCID"></el-table-column>
            <el-table-column prop="3" label="接入号"></el-table-column>
            <el-table-column prop="4" label="层级关系"></el-table-column>
            <el-table-column prop="5" label="操作类型"></el-table-column>
            <el-table-column prop="6" label="操作来源"></el-table-column>
            <el-table-column prop="6" label="操作人"></el-table-column>>
            <el-table-column prop="6" label="操作时间"></el-table-column>>
        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[100, 200, 300, 400]"
            :page-size="100"
            layout="total, sizes, prev, pager, next, jumper"
            :total="400">
        </el-pagination>        
    </div>
</template>
<script>
export default {
    data(){
        return {
            systemOrderForm: {
                date: '',
                agentName: ''
            },
            tableData: [
                {
                    2: '123123',
                    3: 'aaaaaaa',
                    4: 'ooooooo'
                },
                {
                    2: 'q123123',
                    3: 'qaaaaaaa',
                    4: 'qooooooo'
                }
            ],
            multipleSelection: []
        }
    },
    methods: {
        handleSelectionChange(val){
            this.multipleSelection = val;
            console.log(val)
        }
    }
}
</script>
<style lang="less" scoped>

</style>

